import { setProjectState } from '@starflow/app/store';
import { config } from '@shakkerai/config';
import { eventBus } from '@starflow/app/helpers';
import { getProjectState } from '@starflow/app/store';
import { FlOW_PROJECT_INFO, FlOW_SOCKET_INFO, FlOW_TYPE, flowPublicPath, UNIT_TYPE } from '../../constants';
import { useEffect, useState } from 'react';
import { request } from '@shakkerai/services';
import { useDebouncedCallback } from '@mantine/hooks';
import { getProjectId } from '@starflow/app/utils';

const useFlowSyncInit = () => {
  // const [changingFlow, setChangingFlow] = useState([]);
  const syncFlow = async (data) => {
    const { flows, nodeMap, workSpaceUuid } = getProjectState();
    const flow = flows.find((flow) => flow.flowId === data.flowId);
    if (data.tp === FlOW_TYPE.NEW) {
      const res = await fetchFLow(
        {
          content: JSON.stringify({
            ...flow,
            data: {
              ...flow.data,
              nodes: flow.data.nodes.map((node) => nodeMap[node]),
            },
          }),
          workspaceUuid: workSpaceUuid,
          projectId: getProjectId(),
        },
        data.tp,
      );
      const newFlows = [...flows];
      setProjectState({
        flows: newFlows.map((f) => {
          if (f.flowId === flow.flowId) {
            return {
              ...f,
              workSpaceStreamUuid: res.uuid,
            };
          }
          return f;
        }),
      });
    } else if (data.tp === FlOW_TYPE.DEL) {
      fetchFLow({
        content: '',
        uuid: data.target.workSpaceStreamUuid,
        projectId: getProjectId(),
      });
    } else {
      fetchFLow({
        content: JSON.stringify({
          ...flow,
          data: {
            ...flow.data,
            nodes: flow.data.nodes.map((node) => nodeMap[node]),
          },
        }),
        uuid: flow.workSpaceStreamUuid,
        projectId: getProjectId(),
      });
    }
    // setChangingFlow([...changingFlow, data]);
  };

  const fetchFLow = async (params, type) => {
    try {
      const res = await request(`/api/canva/workspace-stream/${type === FlOW_TYPE.NEW ? 'save' : 'modify'}`, params);
      if (res.code === 0) {
        return res.data;
      } else {
        console.log(`${type === FlOW_TYPE.NEW ? 'save' : 'modify'}[flow]异常`, JSON.stringify(res));
      }
    } catch (err) {
      console.log(`${type === FlOW_TYPE.NEW ? 'save' : 'modify'}[flow]异常`, err);
    }
  };

  const fetchUnit = async (params, type) => {
    try {
      const res = await request(`/api/canva/workspace/${type === UNIT_TYPE.NEW ? 'save' : 'modify'}`, params);
      if (res.code === 0) {
        type === UNIT_TYPE.NEW && setProjectState({ workSpaceUuid: res.data.uuid });
      } else {
        console.log(`流${type === UNIT_TYPE.NEW ? 'save' : 'modify'}[unit]异常`, JSON.stringify(res));
      }
    } catch (err) {
      console.log(`流${type === UNIT_TYPE.NEW ? 'save' : 'modify'}[unit]异常`, err);
    }
  };

  const createUnitData = async (type) => {
    const { projectTitle, units, nodeMap } = getProjectState();
    await fetchUnit(
      {
        content: JSON.stringify({
          nodes: units.nodes.map((node) => nodeMap[node]),
        }),
        projectId: getProjectId(),
        name: projectTitle,
      },
      type,
    );
  };

  const updateUnitData = useDebouncedCallback(async () => {
    const { projectTitle, units, nodeMap, workSpaceUuid } = getProjectState();
    await fetchUnit({
      content: JSON.stringify({
        nodes: units.nodes.map((node) => nodeMap[node]),
      }),
      uuid: workSpaceUuid, // uuid的workSpaceUuid是第一次保存会本地有值，如果刷新页面，该值从接口取到后存到state，所以backup从state中获取
      projectId: getProjectId(),
      name: projectTitle,
    });
  }, 2000);

  const syncUnit = (type) => {
    if (type === UNIT_TYPE.NEW) {
      createUnitData(type);
    } else {
      updateUnitData(); // 包含删除
    }
  };

  useEffect(() => {
    eventBus.on(FlOW_SOCKET_INFO, syncFlow);
    eventBus.on(FlOW_PROJECT_INFO, syncUnit);
    return () => {
      eventBus.off(FlOW_SOCKET_INFO, syncFlow);
      eventBus.off(FlOW_PROJECT_INFO, syncUnit);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
export default useFlowSyncInit;
